<div class="container">
  <!-- Legend -->
  <div class="legend">
    <div class="header kader-label">Op Kader</div>
    <div class="header duoprop-label">Duoprop</div>
    <div class="header destroy-label">Afbraak</div>
  </div>

  <!-- Employee Recovery Stats -->
  <div class="employee-stats" *ngFor="let employee of performanceList">
    <div class="employee-name">{{ employee.name }}</div>
    <div class="stat kader-label">{{ employee.frameCount }}</div>
    <div class="stat duoprop-label">{{ employee.duopropCount }}</div>
    <div class="stat destroy-label">{{ employee.destroyCount }}</div>
  </div>
</div>
